

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { LocationFilterState } from 'model/state';
import { LocationFilters } from 'model';
import { FetchLocationsFn } from '../../../containers/Locations';


export function useLocationService(
  userId:               string | null | undefined,
  parentId:             string | undefined,
  search:               string,
  filters:              LocationFilterState,
  currentPage:          number,
  isSubmitting:         boolean,
  hasError:             boolean,
  fetchLocations:       FetchLocationsFn,
  reinitPageCount:      () => void,
  updateSearch:         (search: string) => void,
  updateFilters:        (filters: LocationFilters) => void,
  apiCacheDisabled?:    boolean,
  successCallback?:     () => void,
): void {

  useEffect(() => {
    return function cleanup() {
      reinitPageCount();
      updateSearch('');
      updateFilters({
        type: null,
        cities:[],
        states: [],
        countries: [],
        zipCodes: [],
      });
    };
  }, [parentId]);

  const searchValue = search.trim().length > 2 ? search.trim() : '';

  useEffect(() => {
    if (userId && !isSubmitting && !hasError) {
      if (successCallback) {
        successCallback();
      }
      fetchLocations(userId, currentPage, parentId, searchValue, filters, ['nickname', 'address'], !apiCacheDisabled);
    }
  }, [isSubmitting, userId, parentId, currentPage, searchValue, JSON.stringify(filters)]);
}
